import React from 'react';
import PropTypes from 'prop-types';

import Translate from '@hydra/common/components/i18n';

import CriteriumCompetitors from '@hydra/common/criterium/CriteriumCompetitors';
import CriteriumText from '@hydra/common/criterium/CriteriumText';
import Criterium from '@hydra/common/criterium/Criterium';
import hasCritData from '@hydra/utils/hasCritData';

const getProps = data => {
  return {
    firstLine: data.length > 0 ? data.value + (data.truncated ? '…' : '') : <Translate content='missing' />,
    secondLine: data.value && data.length > 0 ? <Translate content='title_length' with={{ length: data.length, pixelLength: data.pixelLength }} /> : null
  };
};

export const Title = ({ criterium, competitors = [] }) => {
  const { data, url } = criterium;

  const singleContent = <CriteriumText {...getProps(data)} />;
  let compContent;
  if (competitors.length > 0) {
    const compComponents = [
      { component: singleContent, url },
      ...competitors.map(({ criteria }) => {
        if (!hasCritData(criteria.title)) {
          return null;
        }
        return {
          component: <CriteriumText {...getProps(criteria.title.data)} />,
          url: criteria.title.url
        };
      })
    ];
    compContent = <CriteriumCompetitors competitors={compComponents} />;
  }

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {compContent || singleContent}
    </Criterium>
  );
};

Title.propTypes = {
  competitors: PropTypes.arrayOf(
    PropTypes.shape({
      criteria: PropTypes.shape({
        title: PropTypes.shape({
          data: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
          ]),
          url: PropTypes.string
        })
      })
    })
  ),
  criterium: PropTypes.shape({
    data: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ])
  })
};

export default React.memo(Title);
